<template>
  <drag-modal :visible="$store.state.dislog.police" @cancel="reset" :title="'添加进度-' + litetit"
    :class="{ editbox: Edit }" width="860px">
    <div class="navbox" v-if="Edit">
      <Nscroll @getIndex="see" @delCopy="copydel" :openEdit="openEdit"></Nscroll>
      <div class="intopbtn" v-if="!isAllDis">
        <!-- <a-popconfirm title="确认新增此进度吗?" ok-text="确定" cancel-text="取消" @confirm="copyNew">
          <a-button icon="plus" v-if='!openEdit'>新增本进度</a-button>
        </a-popconfirm> -->
        <a-popconfirm title="确认删除当前进度吗?" ok-text="确定" cancel-text="取消" @confirm="delStep" v-if="
          step != 181 && $store.state.DisForm.infoList &&
          $common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.del)
        ">
          <a-button type="danger" icon="delete" style="margin-left: 12px">删除</a-button>
        </a-popconfirm>
        <a-button icon="edit"
          v-if="$common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.edit) && $store.getters.publicPower"
          style="margin-left: 10px" @click="openEdit = !openEdit">{{ openEdit ? '修改' : '取消修改' }}</a-button>
      </div>
    </div>
    <div class="warning-tips" v-if="form.agent.length == 0 && step == 120 && Edit">
      <span>注：系统针对代理人模块进行了架构更新，检测到当前进度的代理人相关信息需要完善，请完善信息后提交</span>
    </div>
    <a-spin :spinning="loading">
      <div class="twobox">
        <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 10 }" :wrapper-col="{ span: 24 }">
          <a-row :gutter="24" v-if="step != 125">
            <a-col :span="8">
              <a-form-model-item label="费用模式" prop='cost_model' labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请选择费用模式', trigger: 'change' }">
                <a-select v-model="form.cost_model" :placeholder="!openEdit ? '请选择费用模式' : ''" :disabled='openEdit'>
                  <a-select-option v-for="row in costmodelList" :key="row.id" :value="row.id">{{ row.option_name
                  }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="代理模式" prop='agent_model' labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请选择代理模式', trigger: 'change' }">
                <a-select v-model="form.agent_model" :placeholder="!openEdit ? '请选择代理模式' : ''" @change="agentmodelChange"
                  :disabled='openEdit'>
                  <a-select-option v-for="row in agentmodelList" :key="row.id" :value="row.id"
                    :disabled="row.status == 0">{{ row.option_name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="代理人" labelAlign="left" style="margin-top: -15px;" prop="agent" :rules="{
                required: true, message: '请选择代理人', trigger: 'change',
              }">
                <a-select v-model="form.agent" :placeholder="!openEdit ? '请选择代理人' : ''" mode="multiple"
                  :disabled='openEdit'>
                  <a-select-option v-for="row in agentList" :key="row.id" :value="row.id">{{ row.name
                  }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24" v-if="step != 125">
            <a-col :span="8">
              <a-form-model-item label="案号" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: false, message: '请输入案号', trigger: 'blur' }">
                <a-input v-model="form.no" :disabled='openEdit' :placeholder="!openEdit ? '请输入案号' : ''" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24" v-if="step != 125">
            <a-col :span="8">
              <a-form-model-item :label="(step == 121 ? '申请' : '立案') + '方式'" class="ckbox" labelAlign="left"
                style="margin-top: -15px;">
                <div class="li" v-for="(i, index) in plainOptions" :key="index" :class="{ 'cur': i.value == form.type }"
                @click="!openEdit ? ck(i.value) : ''">{{ i.label }}</div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24" v-if="step != 125">
            <a-col :span="8" v-if='form.type == 1'>
              <a-form-model-item label="平台名称" prop="platform" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请输入平台名称', trigger: 'blur' }">
                <a-auto-complete :data-source="data" style="width: 100%;" v-model='form.platform' @search="handleSearch"
                  :placeholder="!openEdit ? '请填写平台名称' : ''" :disabled='openEdit'   />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 1'>
              <a-form-model-item label="材料提交时间" prop="submit_time" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请选择材料提交时间', trigger: 'change' }">
                <a-date-picker v-model="form.submit_time" :placeholder="!openEdit ? '请选择材料提交时间' : ''" style="width: 100%;"
                  show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'   />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 2'>
              <a-form-model-item label="单号" prop="ship_no" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请输入单号', trigger: 'blur' }">
                <a-input v-model="form.ship_no" :disabled='openEdit' :placeholder="!openEdit ? '请输入单号' : ''" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 2'>
              <a-form-model-item label="联系方式" prop="ship_phone" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请输入联系方式', trigger: 'blur' }">
                <a-input v-model="form.ship_phone" :disabled='openEdit' :placeholder="!openEdit ? '请输入联系方式' : ''" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 2'>
              <a-form-model-item label="材料名称" prop="filename" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                <a-input v-model="form.filename" :disabled='openEdit' :placeholder="!openEdit ? '请输入材料名称' : ''" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 2'>
              <a-form-model-item label="收件人" prop="receive_name" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请输入收件人', trigger: 'blur' }">
                <a-input v-model="form.receive_name" :disabled='openEdit' :placeholder="!openEdit ? '请输入收件人' : ''" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 2'>
              <a-form-model-item label="寄出时间" prop="ship_time" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请选择寄出时间', trigger: 'change' }">
                <a-date-picker v-model="form.ship_time" :placeholder="!openEdit ? '请选择寄出时间' : ''" style="width: 100%;"
                  show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss'
                  :disabled='openEdit'   />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 2'>
              <a-form-model-item label="" :label-col="{ span: 24 }" style="margin-top: -10px;">
                <label v-if='openEdit'>{{ form.gout == "a" ? "签收时间:" : (form.gout == "b" ? "拒收时间:" : "无") }}</label>
                <a-radio-group v-model='form.gout' :disabled='openEdit' size='small' style="white-space:nowrap;" v-else>
                  <a-radio-button :value="null" style="width:64px;text-align:center;font-size:12px;">无</a-radio-button>
                  <a-radio-button :value="'a'"
                    style="width:68px;font-size:12px;text-align:center;">签收时间</a-radio-button>
                  <a-radio-button :value="'b'"
                    style="width:68px;font-size:12px;text-align:center;">拒收时间</a-radio-button>
                </a-radio-group>
                <a-date-picker v-model="form.receive_time" :placeholder="!openEdit ? '请选择' : ''" show-time
                  valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' v-if='form.gout == "a"'
                  :disabled='openEdit' style="width:100%;" />
                <a-date-picker v-model="form.return_time" :placeholder="!openEdit ? '请选择' : ''" show-time
                  valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                  style="width:100%;" v-if='form.gout == "b"' />
                <a-input disabled v-if='!form.gout' />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 3'>
              <a-form-model-item :label="(step == 121 ? '申请' : '立案') + '时间'" prop="filing_time" labelAlign="left"
                style="margin-top: -15px;" :rules="{ required: true, message: step == 121 ? '请选择申请时间' : '请选择立案时间', trigger: 'change' }">
                <a-date-picker v-model="form.filing_time" :placeholder="!openEdit ? step == 121 ? '请选择申请时间' : '请选择立案时间' : ''" style="width: 100%;"
                  show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'   />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 3'>
              <a-form-model-item :label="(step == 121 ? '申请' : '立案') + '地点'" prop="filing_location" labelAlign="left"
                style="margin-top: -15px;" :rules="{ required: true, message: step == 121 ? '请输入申请地点' : '请输入立案地点', trigger: 'blur' }">
                <a-input v-model="form.filing_location" :disabled='openEdit' :placeholder="!openEdit ? step == 121 ? '请输入申请地点' : '请输入立案地点' : ''" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='form.type == 3'>
              <a-form-model-item label="提交人" prop="submiter" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请输入提交人', trigger: 'blur' }">
                <a-input v-model="form.submiter" :disabled='openEdit' :placeholder="!openEdit ? '请输入我方提交人' : ''" />
              </a-form-model-item>
            </a-col>
            <!-- <a-col :span="8" v-if="form.type > 0">
                <a-form-model-item label="联系人及方式" prop='court_tel' labelAlign="left" style="margin-top: -15px;"
                  :rules="{ required: false, message: '请输入立案联系方式', trigger: 'blur' }">
                  <a-input style="width:100%;" v-model="form.court_tel" placeholder="请输入联系人及方式" :disabled='openEdit'   />
                </a-form-model-item>
              </a-col> -->
            <a-col :span="8" v-if='form.type == 2'>
              <a-form-model-item label="收件地址" prop="addr" labelAlign="left" style="margin-top: -15px;"
                :rules="{ required: true, message: '请输入收件地址', trigger: 'blur' }">
                <a-input v-model="form.addr" :disabled='openEdit' :placeholder="!openEdit ? '请输入收件地址' : ''"
                  style="width:100%;" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8" v-if='step == 125'>
              <a-form-model-item label="类型" prop="type"
                :rules="{ required: true, message: '请选择类型', trigger: 'change', }" labelAlign="left"
                style="margin-top: -15px;">
                <a-select v-model="form.type" :placeholder="!openEdit ? '请选择类型' : ''" :disabled="openEdit">
                  <a-select-option :value="0">请选择</a-select-option>
                  <a-select-option :value="1">中止审理</a-select-option>
                  <a-select-option :value="2">终止审理</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="时间" prop="time" :rules="{ required: true, message: '请选择时间', trigger: 'change' }"
                labelAlign="left" style="margin-top: -15px;">
                <a-date-picker v-model="form.time" :placeholder="!openEdit ? '请选择时间' : ''" style="width: 100%" type="date"
                  valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" :disabled="openEdit" />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="阶段" prop="case_stage"
                :rules="{ required: true, message: '请选择阶段', trigger: 'change' }" labelAlign="left"
                style="margin-top: -15px;">
                <a-select v-model="form.case_stage" :placeholder="!openEdit ? '请选择阶段' : ''" :disabled="openEdit">
                  <a-select-option :value="1" v-if="$store.state.cause.cause_type == 1">诉讼</a-select-option>
                  <a-select-option :value="2" v-else>仲裁</a-select-option>
                  <a-select-option :value="3">执行</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="原因" prop="reason"
                :rules="{ required: true, message: '请选择原因', trigger: 'change' }" labelAlign="left"
                style="margin-top: -15px;">
                <a-select v-model="form.reason" :placeholder="!openEdit ? '请选择原因' : ''" :disabled="openEdit">
                  <a-select-option :value="0">请选择</a-select-option>
                  <a-select-option :value="1">{{ step != 125 ? `${ygName}申请` : ($store.state.cause.cause_type == 1 ?
                    '法院依职权'
                    : '调解中心依职权'
                  ) }}</a-select-option>
                  <a-select-option :value="2">{{ step != 125 ? `${bgName}申请` : `${ygName}申请` }}</a-select-option>
                  <a-select-option :value="3">{{ step != 125 ? '法院移送' : `${bgName}申请` }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <!-- <a-form-model-item label="事由" prop="matter" :rules="{ required: true, message: '请输入事由', trigger: 'blur' }"
            :label-col="{ span: 3 }" :wrapper-col="{ span: 10 }">
            <a-input type="text" placeholder="请输入事由" v-model="form.matter" :disabled="openEdit"></a-input>
          </a-form-model-item> -->
            <a-col :span="8" v-if='step != 125'>
              <a-form-model-item label="承办人" prop="undertaker"
                :rules="{ required: false, message: '请输入承办人', trigger: 'blur' }" labelAlign="left"
                style="margin-top: -15px;">
                <a-input type="text" :placeholder="!openEdit ? '请输入承办人' : ''" v-model="form.undertaker"
                  :disabled="openEdit"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if='step != 125'>
              <a-form-model-item label="联系方式" prop="tel"
                :rules="{ required: false, message: '请输入联系方式', trigger: 'blur' }" labelAlign="left"
                style="margin-top: -15px;">
                <a-input type="text" :placeholder="!openEdit ? '请输入联系方式' : ''" v-model="form.tel"
                  :disabled="openEdit"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-form-model-item label="备注" prop="content" :rules="{ required: false, message: '请输入备注', trigger: 'change' }"
            labelAlign="left" style="margin-top: -15px;">
            <Textarea :content="form.content" @contentVal="(element) => { form.content = element; }"
              :edit="openEdit" :keyArr="['time', 'user']">
            </Textarea> 
          </a-form-model-item>
          <div>
            <div class="licter" v-if='!openEdit'>
              <label>补充材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click="plusAdd(1)">电子</a>
                <a href="javascript:void(0);" @click="plusAdd(2)">微信</a>
                <a href="javascript:void(0);" @click="plusAdd(3)">现场</a>
                <a href="javascript:void(0);" @click="plusAdd(4)">邮寄</a>
              </div>
            </div>
            <div class="ilikecon">
              <div class="ilikebox" v-for='(i, index) in form.supp' :key='index'>
                <div class="likebox" v-if='i.type == 1'>
                  <div class="htit">补充材料：电子
                    <span @click='del(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="平台名称" :prop="'supp.' + index + '.platform'"
                        :rules="{ required: true, message: '请输入平台名称', trigger: 'blur' }">
                        <a-input v-model="i.platform" :disabled='openEdit' placeholder="请输入平台名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'"
                        :rules="{ required: true, message: '请选择补充时间', trigger: 'change' }">
                        <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type == 2'>
                  <div class="htit">补充材料：微信
                    <span @click='del(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="对方微信号" :prop="'supp.' + index + '.wx'"
                        :rules="{ required: true, message: '请输入对方微信号', trigger: 'blur' }">
                        <a-input v-model="i.wx" :disabled='openEdit' placeholder="请输入对方微信号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'"
                        :rules="{ required: true, message: '请输入补充时间', trigger: 'change' }">
                        <a-date-picker v-model="i.time" placeholder="请输入补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea'  placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type == 3'>
                  <div class="htit">
                    补充材料：现场
                    <span @click='del(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="补充提交人" :prop="'supp.' + index + '.submiter'"
                        :rules="{ required: true, message: '请输入补充提交人', trigger: 'blur' }">
                        <a-input v-model="i.submiter" :disabled='openEdit' placeholder="请输入" />
                      </a-form-model-item>
                    </a-col>

                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入补充提交人" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'"
                        :rules="{ required: true, message: '请选择补充时间', trigger: 'change' }">
                        <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea'  placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type == 4'>
                  <div class="htit">
                    补充材料：邮寄
                    <span @click='del(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="单号" :prop="'supp.' + index + '.ship_no'"
                        :rules="{ required: true, message: '请输入单号', trigger: 'blur' }">
                        <a-input v-model="i.ship_no" :disabled='openEdit' placeholder="请输入单号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' placeholder="请输入" />
                      </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'supp.' + index + '.tel'"
                        :rules="{ required: true, message: '请输入联系方式', trigger: 'blur' }">
                        <a-input v-model="i.tel" :disabled='openEdit' placeholder="请输入联系方式" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="收件人" :prop="'supp.' + index + '.receive_name'"
                        :rules="{ required: true, message: '请输入收件人', trigger: 'blur' }">
                        <a-input v-model="i.receive_name" :disabled='openEdit' placeholder="请输入收件人" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="寄出时间" :prop="'supp.' + index + '.ship_time'"
                        :rules="{ required: true, message: '请选择寄出时间', trigger: 'change' }">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="">
                        <label v-if='openEdit'>{{ i.gout == "a" ? "签收时间:" : (i.gout == "b" ? "拒收时间:" : "无") }}</label>
                        <a-radio-group v-model='i.gout' :disabled='openEdit' size='small' style="white-space:nowrap;"
                          v-else>
                          <a-radio-button :value="null"
                            style="width:64px;text-align:center;font-size:12px;">无</a-radio-button>
                          <a-radio-button :value="'a'"
                            style="width:68px;font-size:12px;text-align:center;">签收时间</a-radio-button>
                          <a-radio-button :value="'b'"
                            style="width:68px;font-size:12px;text-align:center;">拒收时间</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' v-if='i.gout == "a"'
                          :disabled='openEdit' style="width:100%;" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                          style="width:100%;" v-if='i.gout == "b"' />
                        <a-input disabled v-if='!i.gout' />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span='12'>
                      <a-form-model-item label="收件地址" :prop="'supp.' + index + '.addr'"
                        :rules="{ required: true, message: '请输入收件地址', trigger: 'blur' }">
                        <a-input v-model="i.addr" :disabled='openEdit' type="textarea" placeholder="请输入收件地址" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='12'>
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>

            <div class="licter" v-if='!openEdit'>
              <label>接收材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click="plusAdd(1, 1)">电子</a>
                <a href="javascript:void(0);" @click="plusAdd(2, 1)">微信</a>
                <a href="javascript:void(0);" @click="plusAdd(3, 1)">现场</a>
                <a href="javascript:void(0);" @click="plusAdd(4, 1)">邮寄</a>
              </div>
            </div>
            <div class="ilikecon" style="margin-top:10px;">
              <div class="ilikebox" v-for='(i, index) in form.accept_file' :key='index'>
                <div class="likebox" v-if='i.type == 1'>
                  <div class="htit">接收材料：电子
                    <span @click='supdel(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="平台名称" :prop="'accept_file.' + index + '.platform'"
                        :rules="{ required: true, message: '请输入平台名称', trigger: 'blur' }">
                        <a-input v-model="i.platform" :disabled='openEdit' placeholder="请输入平台名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'"
                        :rules="{ required: true, message: '请选择接收时间', trigger: 'change' }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type == 2'>
                  <div class="htit">接收材料：微信
                    <span @click='supdel(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="对方微信号" :prop="'accept_file.' + index + '.wx'"
                        :rules="{ required: true, message: '请输入对方微信号', trigger: 'blur' }">
                        <a-input v-model="i.wx" :disabled='openEdit' placeholder="请输入对方微信号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'"
                        :rules="{ required: true, message: '请选择接收时间', trigger: 'change' }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type == 3'>
                  <div class="htit">
                    接收材料：现场
                    <span @click='supdel(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.submiter'"
                        :rules="{ required: true, message: '请输入接收人', trigger: 'blur' }">
                        <a-input v-model="i.submiter" :disabled='openEdit' placeholder="请输入接收人" />
                      </a-form-model-item>
                    </a-col>

                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'"
                        :rules="{ required: true, message: '请选择接收时间', trigger: 'change' }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span='24'>
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type='textarea' placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if='i.type == 4'>
                  <div class="htit">
                    接收材料：邮寄
                    <span @click='supdel(index)' v-if='!openEdit'>
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="单号" :prop="'accept_file.' + index + '.ship_no'"
                        :rules="{ required: true, message: '请输入单号', trigger: 'blur' }">
                        <a-input v-model="i.ship_no" :disabled='openEdit' placeholder="请输入单号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' placeholder="请输入" />
                      </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'accept_file.' + index + '.tel'"
                        :rules="{ required: true, message: '请输入联系方式', trigger: 'blur' }">
                        <a-input v-model="i.tel" :disabled='openEdit' placeholder="请输入联系方式" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'"
                        :rules="{ required: true, message: '请输入材料名称', trigger: 'blur' }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span='8'>
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.receive_name'"
                        :rules="{ required: true, message: '请输入接收人', trigger: 'blur' }">
                        <a-input v-model="i.receive_name" :disabled='openEdit' placeholder="请输入接收人" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="寄出时间" :prop="'accept_file.' + index + '.ship_time'"
                        :rules="{ required: true, message: '请选择寄出时间', trigger: 'change' }">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                          style="width:100%;" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='8'>
                      <a-form-model-item label="">
                        <label v-if='openEdit'>{{ i.gout == "a" ? "签收时间" : (i.gout == "b" ? "拒收时间" : "无") }}</label>
                        <a-radio-group v-model='i.gout' :disabled='openEdit' size='small' style="white-space:nowrap;"
                          v-else>
                          <a-radio-button :value="null"
                            style="width:64px;text-align:center;font-size:12px;">无</a-radio-button>
                          <a-radio-button :value="'a'"
                            style="width:68px;font-size:12px;text-align:center;">签收时间</a-radio-button>
                          <a-radio-button :value="'b'"
                            style="width:68px;font-size:12px;text-align:center;">拒收时间</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' v-if='i.gout == "a"'
                          :disabled='openEdit' style="width:100%;" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time
                          valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='openEdit'
                          style="width:100%;" v-if='i.gout == "b"' />
                        <a-input disabled v-if='!i.gout' />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span='12'>
                      <a-form-model-item label="收件地址" :prop="'accept_file.' + index + '.addr'"
                        :rules="{ required: true, message: '请输入收件地址', trigger: 'blur' }">
                        <a-input v-model="i.addr" :disabled='openEdit' type="textarea" placeholder="请输入收件地址" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span='12'>
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled='openEdit' type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>
          </div>
          <a-form-model-item :wrapper-col="{ span: 24 }" style="margin-top: 20px">
            <Upload @isDisabled="parentHandle" :fList="List" @upFileAfter="(element) => { form.files = element; }"
             :disabled="openEdit" :edit="openEdit" v-if="!loading" />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 24 }" v-if="!openEdit" style="text-align: center">
            <a-popconfirm :disabled="disabledShow" title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
              <a-button :disabled="disabledShow" type="primary" style="width: 148px"> 提交 </a-button>
            </a-popconfirm>
            <a-button style="margin-left: 20px;width: 148px; background: #b2c9e1; color: #fff; "
              @click="reset">取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-spin>
  </drag-modal>
</template>
<script>
const formItem = {
  content: [{}],
  reason: '',
  type: 1,
  matter: '',
  time: '',
  files: [],
}
import Nscroll from '@/components/nscroll'
import Upload from '@/components/uploads'
import { mapGetters, mapActions } from 'vuex'
import { jcyspjdAdd, jcyspjdEdit, jcyspjdLists, delJd } from '@/server/speed'
import { attorneyoptions } from "@/server/directory"
import Textarea from '@/components/textarea'
import fy from "../fy"
export default {
  name: 'Police',
  props: {
    agentmodelList: Array,
    costmodelList: Array,
  },
  computed: {
    ...mapGetters(['litetit', 'Edit']),
    liteKey() {
      return this.step == 120 ? 'sxajzc' : "jcyspjd"
    },
    ygName() {
      return this.$store.state.cause.cause_type == 1 ? '原告' : '申请人'
    },
    bgName() {
      return this.$store.state.cause.cause_type == 1 ? '被告' : '被申请人'
    }
  },
  components: {
    Textarea,
    Upload,
    Nscroll,
  },
  data() {
    return {
      List: [],
      isAllDis: this.$route.query.t,
      form: JSON.parse(JSON.stringify(formItem)),
      step: this.$store.state.StepLite,
      rules: {},
      form: {
        supp: [],
        accept_file: [],
        content: [{}],
        type: 1,
        case_stage: '',
        agent: [],
        agent_model: undefined,
        cost_model: undefined
      },
      loading: true,
      openEdit: false,
      disabledShow: false,
      agentList: [],
      plainOptions: [
        { label: '网立', value: 1 },
        { label: '邮寄', value: 2 },
        { label: '现场', value: 3 },
      ],
      data: [],
      fy,
      stage: '',
      stage_inside: '',
      stage_outside: ''
    }
  },
  created() {
    if (this.Edit) {
      this.$nextTick(() => {
        jcyspjdLists({
          cause_id: this.$store.state.cause.id,
          step: this.step,
        }, this.step).then((e) => {
          e.list.map((ele) => {
            ele[this.liteKey].content = JSON.stringify(ele[this.liteKey].content) == '{}' || JSON.stringify(ele[this.liteKey].content) == 'null' ? [{ content: '' }] : Object.keys(ele[this.liteKey].content).map((key) => ele[this.liteKey].content[key])
          })
          this.Infokey({ key: 'infoList', value: e.list })
          this.see(0)
          this.$store.dispatch("settime", e.list[0][this.liteKey].update_time)
        })
      })
      this.openEdit = true
      this.loading = false
    } else {
      this.loading = false
    }
  },
  methods: {
    gtLetter() {
      return (JSON.parse(localStorage.getItem("pName")) || []).concat(this.fy).filter(ele => { return ele })
    },
    handleSearch(value) {
      this.data = !value ? [] : this.gtLetter().filter(ele => { return ele.indexOf(value) >= 0 });
    },
    ck(id) {
      if (id == this.form.type) {
        return
      } else {
        this.form.type = id
      }
    },
    agentmodelChange(e) {
      this.agentmodelList.map(item => {
        if (item.id == e) {
          this.getatt(item.id)
        }
      })
    },
    getatt(id) {
      attorneyoptions(id).then(res => {
        this.agentList = res
      })
    },
    parentHandle(data) {
      this.disabledShow = data
    },
    clearFileds() {
      this.$refs.forms.clearValidate(['content'])
    },
    ...mapActions({
      Newdel: 'DisForm/copydel',
      seeInfo: 'DisForm/see',
      addNew: 'DisForm/addNew',
      Infokey: 'DisForm/setInfokey',
      reMove: 'DisForm/reMove',
    }),
    delStep() {
      let curIndex = this.$store.state.DisForm.curIndex
      let step_id = this.$store.state.DisForm.infoList[curIndex].id
      delJd({ step_id: step_id }).then(e => {
        this.$message.success("已提交审核")
        setTimeout(e => {
          window.history.go(0)
        }, 500)
      })
    },
    async copydel(index) {
      //删除进度
      this.loading = true
      await this.Newdel({
        index: index,
        formKey: ['content', 'reason', 'type', 'matter', 'time'],
        valkey: this.liteKey,
      }).then((e) => {
        this.form = JSON.parse(JSON.stringify(e))
        this.loading = false
      })
    },
    confirm() {
      this.$refs.forms.validate((valid) => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form))
          let curIndex = this.$store.state.DisForm.curIndex
          let isEditCopyAdd =
            this.$store.state.DisForm.copyIndex.indexOf(curIndex) >= 0
              ? true
              : false //当前是否是在修改下的新增
          if (form.files && form.files.length > 0) {
            form.files = form.files.map((ele) => {
              return ele.upload_id || ele
            })
          }
          form.content = form.content.filter(ele => { return ele.content })
          form.step = this.$store.state.StepLite
          if (form.type == 0 || form.reason == 0) {
            this.$message.error({ content: '请选择', key: 'updatable' })
            return false
          }
          if (form.step == 120) {
            form.stage = '公安侦查'
          } else if (form.step == 121) {
            form.stage = '审判监督'
          }
          if (form.case_stage == 1) {
            form.stage_inside = '诉讼'
          } else if (form.case_stage == 2) {
            form.stage_inside = '仲裁'
          } else if (form.case_stage == 3) {
            form.stage_inside = '执行'
          }
          form.stage_outside = ''
          if (this.Edit && !isEditCopyAdd) {
            //修改
            let step_id = this.$store.state.DisForm.infoList[curIndex][this.liteKey].id
            form.id = step_id
            jcyspjdEdit(form, this.step).then((e) => {
              this.$message.success({ content: '修改成功', key: 'updatable' })
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          } else {
            form.cause_id = this.$store.state.cause.id
            jcyspjdAdd(form, this.step).then((e) => {
              this.$message.success({ content: '新增成功', key: 'updatable' })
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    del(index) {
      let supp = JSON.parse(JSON.stringify(this.form.supp))
      supp.splice(index, 1)
      this.form.supp = supp
    },
    supdel(index) {
      let supp = JSON.parse(JSON.stringify(this.form.accept_file))
      supp.splice(index, 1)
      this.form.accept_file = supp
    },
    plusAdd(type, lite) {
      let smForm = {
        type: type,
      }
      if (type == 4) {
        smForm.gout = null
      }
      if (lite) {
        this.form.accept_file.push(smForm)
      } else {
        this.form.supp.push(smForm)
      }
    },
    copyNew() {
      //新增复制进度
      this.loading = true
      let copyItem = {
        cause_id: null,
        id: null,
        jcyspjd: formItem,
        title: this.litetit,
      }
      this.addNew(copyItem).then((index) => {
        this.form = JSON.parse(JSON.stringify(formItem))
        this.loading = false
      })
    },
    async see(index) {
      //查看切换 审批
      this.loading = true
      this.seeInfo({
        index: index,
        formKey: this.step == 120 ? ['content', 'reason', 'undertaker', 'matter', 'time', 'tel', 'accept_file', 'supp',
          'agent', 'agent_model', 'cost_model', 'no', 'case_stage', 'type', 'platform', 'submit_time', 'ship_no', 'ship_phone',
          'filename', 'receive_name', 'ship_time', 'receive_time', 'reject_time', 'addr', 'filing_time', 'filing_location', 'submiter'] : ['content', 'reason', 'type', 'matter', 'time', 'accept_file', 'supp', 'agent', 'agent_model', 'cost_model','case_stage'],
        valkey: this.liteKey,
      }).then((e) => {
        let form = JSON.parse(JSON.stringify(e))
        form.files.map((ele) => {
          ele.title = ele.origin_name || ele.title
          ele.upload_id = ele.upload_id
          ele.id = ele.id
        })
        this.List = form.files
        if (form.agent == null || form.agent == NaN) {
          form.agent = []
        }
        if (form.agent_model == 0 || form.agent_model == 3 || form.agent_model == 4 || form.agent_model == 10) {
          form.agent_model = ''
        } else {
          form.agent_model = Number(form.agent_model)
        }
        this.old_agent_model = form.agent_model
        this.old_agent = form.agent
        this.agentmodelList.map(item => {
          if (item.id == form.agent_model) {
            this.getatt(item.id)
          }
        })
        if (form.cost_model == 0) {
          form.cost_model = ''
        } else {
          form.cost_model = Number(form.cost_model)
        }
        form.accept_file = form.accept_file || []
        form.supp = form.supp || []
        this.form = form
        this.loading = false
      })
    },
    reset() {
      this.reMove().then((e) => {
        // this.$refs.forms.resetFields()
        this.$store.dispatch('openkey', { key: 'police', by: false })
      })
    },
    lisUpload(fileList) {
      this.form.files = fileList
    },
  },
}
</script>
<style lang="less" scoped>
.licter {
  overflow: hidden;
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  label {
    float: left;
    font-size: 0.875rem;
    text-align: right;
    color: #333;
    line-height: 30px;
    margin-right: 10px;
  }

  .clearbtn {
    float: left;
  }

  .rmain {
    // padding-left: 20px;
    // margin-left: 20px;
    float: left;

    a {
      width: 68px;
      line-height: 36px;
      background: #b2c9e1;
      border-radius: 4px;
      display: inline-block;
      margin-right: 20px;
      font-size: 0.875rem;
      color: #fff;
      text-align: center;
      transition-duration: 500ms;

      &:hover {
        background: #1d8bfe;
      }
    }
  }
}

.ilikecon {
  max-height: 400px;
  overflow-y: auto;
}

.likebox {
  padding: 20px;
  background: #f3f6fb;
  margin-bottom: 10px;
  border-radius: 8px;

  .htit {
    font-size: 1rem;
    color: #0e2949;
    line-height: 19px;
    margin-bottom: 12px;

    span {
      color: #f00;
      cursor: pointer;
    }
  }

  /deep/ .ant-form-item {
    margin-bottom: 0;
  }

  /deep/ .ant-form-item-label {
    text-align: left;
  }
}

.ckbox {
  overflow: hidden;

  .li {
    float: left;
    background: url('../../../assets/img/ico.png') no-repeat left center;
    background-size: 15px 15px;
    font-size: 0.75rem;
    padding-right: 20px;
    padding-left: 20px;
    cursor: pointer;
  }

  .cur {
    background-image: url('../../../assets/img/icoh.png');
  }
}
</style>